import { createSlice } from '@reduxjs/toolkit';

import type {
  HttpClientPreferenceParams,
  HttpShippingMethodDto
} from '../../dto/HttpShippingMethodDto';
import { getShippingMethods } from '../ShippingMethodsReduxRepository';

interface InitialState {
  data: HttpShippingMethodDto | undefined;
  isLoading: boolean;
  error?: string;
  params?: HttpClientPreferenceParams;
}

const initialState: InitialState = {
  data: undefined,
  isLoading: false,
  params: undefined
};

const ShippingMethodsSlice = createSlice({
  name: 'shippingMethods',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getShippingMethods.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getShippingMethods.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getShippingMethods.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
});

export const shippingMethodsReducer = ShippingMethodsSlice.reducer;
